export const API_DOMAIN = 'controllershiphub.finergy.amazon.dev';
export const AWS_REGION = 'us-east-1';
